module.exports = __webpack_public_path__ + "img/GE Corporate (Intern).301c5fbc.png";